import React from "react";
import LeftPanel from "@components/LeftPanel";
import Map from "@components/Map/index";
import styled from "styled-components";
import { useViewportMode } from "@utils/useMobileDetection";

const StyledDiv = styled.div`
  .home-left {
    flex-shrink: 0;
  }
  .home-right {
    flex-grow: 1;
    min-width: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
`;

const Home = () => {
  const { isMobile, isTablet } = useViewportMode();

  const containerClass = isMobile
    ? "w-full px-[10px] overflow-x-hidden overflow-y-auto"
    : isTablet
      ? "w-full px-[4px] overflow-x-hidden overflow-y-auto h-screen"
      : "max-w-[1100px] w-full mx-auto overflow-x-hidden";

  const flexClass = isMobile
    ? "flex flex-col gap-[8px] py-[8px]"
    : isTablet
      ? "flex flex-row gap-[4px] py-[2px] h-full"
      : "flex flex-row gap-[12px] py-[24px] pt-[64px]";

  const leftStyle = isMobile
    ? {}
    : isTablet
      ? { flexBasis: 220, maxWidth: 220 }
      : { flexBasis: 340 };

  return (
    <StyledDiv className={containerClass}>
      <div className={flexClass}>
        <div className="home-left" style={leftStyle}>
          <LeftPanel />
        </div>
        <div className="home-right">
          <Map />
        </div>
      </div>
    </StyledDiv>
  );
};

export default Home;
